import Vue from 'vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { refreshYotpoWidgets, contains } from 'lib/util'
import select from 'dom-select'

export default el => {
  const children = select.all('.featured-products__item', el)
  return new Vue({
    el,
    data: {
      activeIndex: 0,
      swiperOption: {
        centeredSlides: children.length < 3,
        slidesPerView: 'auto',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        watchOverflow: true,
        navigation: {
          nextEl: '.featured-products__arrow.next',
          prevEl: '.featured-products__arrow.prev'
        },
        watchSlidesVisibility: true
      },
      activeTab: 'feature-tab-0'
    },
    components: {
      swiper,
      swiperSlide
    },
    mounted () {
      setTimeout(() => {
        refreshYotpoWidgets()
      }, 1000)

      this.$nextTick(() => {
        this.toggleSlidesVisibility()
      })

      this.resetSlideButton()
    },
    methods: {
      setActiveCollection (event, index) {
        if (!event.key || event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          if (index === 1) {
            if (!event.key) {
              this.activeIndex = 1
              this.$refs.tab1.focus()
              this.activeTab = 'feature-tab-1'
              this.$refs.tab1.removeAttribute('tabindex')
              this.$refs.tab0.setAttribute('tabindex', '-1')
            } else {
              this.activeIndex = 0
              this.$refs.tab0.focus()
              this.activeTab = 'feature-tab-0'
              this.$refs.tab0.removeAttribute('tabindex')
              this.$refs.tab1.setAttribute('tabindex', '-1')
            }
          } else {
            if (!event.key) {
              this.activeIndex = 0
              this.$refs.tab0.focus()
              this.activeTab = 'feature-tab-0'
              this.$refs.tab0.removeAttribute('tabindex')
              this.$refs.tab1.setAttribute('tabindex', '-1')
            } else {
              this.activeIndex = 1
              this.$refs.tab1.focus()
              this.activeTab = 'feature-tab-1'
              this.$refs.tab1.removeAttribute('tabindex')
              this.$refs.tab0.setAttribute('tabindex', '-1')
            }
          }
          this.$nextTick(() => {
            this.toggleSlidesVisibility()
          })
        }
      },
      setSlideVisibility (slide) {
        const focusableEls = select.all(['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'], slide)
        slide.removeAttribute('aria-hidden')
        if (focusableEls.length) {
          focusableEls.forEach(el => {
            el.removeAttribute('tabindex')
          })
        }
      },
      unsetSlideVisibility (slide) {
        const focusableEls = select.all(['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'], slide)
        slide.setAttribute('aria-hidden', true)
        if (focusableEls.length) {
          focusableEls.forEach(el => {
            el.setAttribute('tabindex', '-1')
          })
        }
      },
      toggleSlidesVisibility () {
        const slides = Array.from(this.$refs.swiper.swiper.slides)
        const swiper = this.$children && this.$children[0] ? this.$children[0].swiper : null
        if (!swiper) {
          return
        }

        slides.forEach((slide, index) => {
          if (contains(slide, 'swiper-slide-visible')) {
            if (swiper.slidesGrid[index] < Math.abs(swiper.translate)) {
              this.unsetSlideVisibility(slide)
            } else {
              this.setSlideVisibility(slide)
            }
          } else {
            this.unsetSlideVisibility(slide)
          }
        })
      },
      resetSlideButton () {
        const buttonPrev = this.$refs.buttonPrev
        const buttonNext = this.$refs.buttonNext
        if (buttonPrev && buttonNext) {
          buttonPrev.removeAttribute('tabindex')
          buttonNext.removeAttribute('tabindex')
        }
      }
    }
  })
}
